import { render, staticRenderFns } from "./IFrameField.vue?vue&type=template&id=d3128d5e"
import script from "./IFrameField.vue?vue&type=script&lang=js"
export * from "./IFrameField.vue?vue&type=script&lang=js"
import style0 from "./IFrameField.vue?vue&type=style&index=0&id=d3128d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports